import UIFlex from 'UIComponents/layout/UIFlex';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import ScrollTrackingWrapper from '../../../components/common/ScrollTrackingWrapper';
import { TRIAL_UPGRADE_FEATURE_PANELS } from '../../../constants/ErrorBoundaryNames';
import { BizObjectivesMap } from '../../../constants/HC0119BizObjectivesMap';
import { SCREENS, UPGRADE_PAGES } from '../../../constants/tracking/Locations';
import { UpgradeTrialPageConfig } from '../../../constants/upgrade-trial/upgradeTrialPageConfig';
import { PanelContent, PanelImage } from './TrialUpgradeFeaturePanelComponents';
import { withErrorBoundary } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TrialUpgradeFeaturePanels = ({
  apiName
}) => {
  const apiNameConfig = UpgradeTrialPageConfig[apiName];
  const Panel = ({
    bizObjective,
    features
  }) => {
    const {
      title,
      subtitle,
      illustration
    } = apiNameConfig ? apiNameConfig[bizObjective] : {
      title: '',
      subtitle: '',
      illustration: ''
    };
    return /*#__PURE__*/_jsx(ScrollTrackingWrapper, {
      scrollTrackingFn: () => {
        getUsageTracker().track('scrollInteraction', {
          action: 'scrolled to business objectives',
          name: bizObjective,
          apiName,
          screen: SCREENS.UPGRADE_PAGE,
          subscreen: UPGRADE_PAGES.TRIAL
        });
      },
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "start",
        justify: "start",
        gap: 0,
        direction: "row",
        className: "p-all-10",
        children: [/*#__PURE__*/_jsx(PanelImage, {
          imageKey: illustration
        }), /*#__PURE__*/_jsx(PanelContent, {
          title: title,
          subtitle: subtitle,
          features: features
        })]
      })
    });
  };
  const bizObjectives = apiNameConfig ? Object.keys(apiNameConfig) : [];
  const renderPanels = () => {
    return bizObjectives.map(bizObjective => {
      const bizObjectivesForApiName = BizObjectivesMap[apiName];
      const features = bizObjectivesForApiName ? bizObjectivesForApiName[bizObjective].features : [];
      return /*#__PURE__*/_jsx(Panel, {
        bizObjective: bizObjective,
        features: features
      }, bizObjective);
    });
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderPanels()
  });
};
export default withErrorBoundary(TrialUpgradeFeaturePanels, {
  boundaryName: TRIAL_UPGRADE_FEATURE_PANELS
});